import { render, staticRenderFns } from "./FolderRenameDialog.vue?vue&type=template&id=9df7f67c&scoped=true"
import script from "./FolderRenameDialog.vue?vue&type=script&lang=ts"
export * from "./FolderRenameDialog.vue?vue&type=script&lang=ts"
import style0 from "./FolderRenameDialog.vue?vue&type=style&index=0&id=9df7f67c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df7f67c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9df7f67c')) {
      api.createRecord('9df7f67c', component.options)
    } else {
      api.reload('9df7f67c', component.options)
    }
    module.hot.accept("./FolderRenameDialog.vue?vue&type=template&id=9df7f67c&scoped=true", function () {
      api.rerender('9df7f67c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/FolderRenameDialog.vue"
export default component.exports